<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Multicolor"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 112">
    <defs>
      <clipPath id="clip-path">
        <circle
          class="cls-1"
          cx="50"
          cy="56.47"
          r="40" />
      </clipPath>
      <clipPath id="clip-path-2">
        <circle
          class="cls-1"
          cx="169.98"
          cy="56.15"
          r="40" />
      </clipPath>
    </defs>
    <title>98- bedtime-bed-bedroom-male-asian-2</title>
    <g id="Background">
      <g
        id="New_Symbol_2-8"
        data-name="New Symbol 2">
        <circle
          class="cls-2"
          cx="50"
          cy="56.47"
          r="40" />
      </g>
    </g>
    <g id="Scene">
      <g class="cls-3">
        <rect
          class="cls-4"
          x="2.52"
          y="14.97"
          width="82.98"
          height="53" />
        <path
          class="cls-5"
          d="M72.52,28A3,3,0,0,0,70,25a119.3,119.3,0,0,0-20-1.5A105.27,105.27,0,0,0,31,25a3,3,0,0,0-2.46,2.95V49.56A3,3,0,0,0,31,52.51,105.27,105.27,0,0,0,50,54a119.3,119.3,0,0,0,20-1.5,3,3,0,0,0,2.49-2.95Z" />
        <path
          class="cls-6"
          d="M50,25A13,13,0,0,0,37,38l.89,15.48c3.2.3,7.23.52,12.11.52s8.81-.21,12.12-.5L63,38A13,13,0,0,0,50,25Z" />
        <path
          class="cls-7"
          d="M72.52,28A3,3,0,0,0,70,25a119.3,119.3,0,0,0-20-1.5A105.27,105.27,0,0,0,31,25a3,3,0,0,0-2.46,2.95V49.56A3,3,0,0,0,31,52.51,105.27,105.27,0,0,0,50,54a119.3,119.3,0,0,0,20-1.5,3,3,0,0,0,2.49-2.95Z" />
        <path
          class="cls-5"
          d="M17.45,27a3,3,0,0,0-2.94-2.51,118.48,118.48,0,0,0-20,1.79A106.06,106.06,0,0,0-24,30.8,3,3,0,0,0-26,34.11l3.54,21.34A3,3,0,0,0-19.51,58a105.61,105.61,0,0,0,19-1.67A119.21,119.21,0,0,0,19,51.53a3,3,0,0,0,2-3.32Z" />
        <path
          class="cls-7"
          d="M17.45,27a3,3,0,0,0-2.94-2.51,118.48,118.48,0,0,0-20,1.79A106.06,106.06,0,0,0-24,30.8,3,3,0,0,0-26,34.11l3.54,21.34A3,3,0,0,0-19.51,58a105.61,105.61,0,0,0,19-1.67A119.21,119.21,0,0,0,19,51.53a3,3,0,0,0,2-3.32Z" />
        <path
          class="cls-8"
          d="M85,82H4.52a2,2,0,0,1-2-2V98h84V81.3A2,2,0,0,1,85,82Z" />
        <path
          class="cls-9"
          d="M85,82H4.52a2,2,0,0,1-2-2v7a2,2,0,0,0,2,2H85a2,2,0,0,0,1.5-.67v-7A2,2,0,0,1,85,82Z" />
        <path
          class="cls-7"
          d="M85,82H4.52a2,2,0,0,1-2-2V98h84V81.3A2,2,0,0,1,85,82Z" />
        <rect
          class="cls-4"
          x="2.52"
          y="67.97"
          width="84.48"
          height="14"
          rx="2"
          ry="2" />
        <path
          class="cls-10"
          d="M59.52,85v2a2.5,2.5,0,0,0,5,0V85Z" />
        <path
          class="cls-5"
          d="M65.52,68.9A15.79,15.79,0,0,0,50.94,53,15.48,15.48,0,0,0,34.55,68l0,1a8,8,0,0,0,8,8H53a1,1,0,0,0,1-1V71H42.52a2,2,0,0,1-2-2V68h19V85h5a1,1,0,0,0,1-1Z" />
        <path
          class="cls-11"
          d="M50,57.47A15.5,15.5,0,0,1,65.52,73h0V68.9A15.79,15.79,0,0,0,50.94,53,15.48,15.48,0,0,0,34.55,68h0a1.15,1.15,0,0,0,1.08-.73A15.5,15.5,0,0,1,50,57.47Z" />
        <path
          class="cls-7"
          d="M65.52,68.9A15.79,15.79,0,0,0,50.94,53,15.48,15.48,0,0,0,34.55,68l0,1a8,8,0,0,0,8,8H53a1,1,0,0,0,1-1V71H42.52a2,2,0,0,1-2-2V68h19V85h5a1,1,0,0,0,1-1Z" />
        <path
          class="cls-12"
          d="M46.52,53.47a3.5,3.5,0,0,0,7,0V50h-7Z" />
        <path
          class="cls-13"
          d="M46.52,53.46a12.26,12.26,0,0,0,7,0V50h-7Z" />
        <path
          class="cls-7"
          d="M46.52,53.47V50h7v3.5a3.5,3.5,0,0,1-7,0Z" />
        <path
          class="cls-14"
          d="M59.61,73.45l-1.13-4.69-.14.66-2.94-.61,1.29,5.35a1.5,1.5,0,0,0,2.92-.71Z" />
        <path
          class="cls-14"
          d="M59,66.06H59l-1.76-.31a1,1,0,0,1-.82-1.09l-1,4.16,2.94.61Z" />
        <polygon
          class="cls-15"
          points="56.54 63.6 48.59 59.38 46.74 61.8 55.58 66.48 56.54 63.6" />
        <polygon
          class="cls-16"
          points="48.74 71.91 49.21 71.03 50.97 71.97 51.88 71.32 52.51 71.65 53.03 70.23 45.08 66.01 44.18 67.24 44.81 67.57 44.79 68.69 46.55 69.63 46.09 70.51 48.74 71.91" />
        <polygon
          class="cls-16"
          points="54.64 68.25 45.8 63.57 45.08 66.01 53.03 70.23 54.64 68.25" />
        <polygon
          class="cls-14"
          points="46.32 70.07 42.79 68.19 33.09 81.16 36.62 83.03 46.32 70.07" />
        <path
          class="cls-14"
          d="M39.1,78.45l-1.89-1.61a1,1,0,0,0-1.49.22l-2.63,4.1L36.62,83l2.61-3.19A1,1,0,0,0,39.1,78.45Z" />
        <path
          class="cls-16"
          d="M37.09,82.15a2.5,2.5,0,0,0-4.42-2.34l-.47.88L36.62,83Z" />
        <path
          class="cls-14"
          d="M44.21,74l-3.46-3.25a1,1,0,0,1-.07-1.37l1.85-2.18A1,1,0,0,1,43.76,67l1.05.56,0,1.12,1.77.94Z" />
        <path
          class="cls-14"
          d="M45.21,69h3a0,0,0,0,1,0,0v6a1,1,0,0,1-1,1h-1a1,1,0,0,1-1-1V69A0,0,0,0,1,45.21,69Z"
          transform="translate(39.4 -13.43) rotate(27.92)" />
        <rect
          class="cls-15"
          x="47.9"
          y="63.71"
          width="3"
          height="7.5"
          transform="translate(37.34 -15.28) rotate(27.92)" />
        <rect
          class="cls-16"
          x="46.03"
          y="69.24"
          width="3"
          height="3.5"
          transform="translate(38.78 -13.99) rotate(27.92)" />
        <line
          class="cls-17"
          x1="42.76"
          y1="69.31"
          x2="43.62"
          y2="70.9" />
        <polygon
          class="cls-14"
          points="48.97 71.47 52.51 73.34 47.22 88.65 43.69 86.78 48.97 71.47" />
        <path
          class="cls-14"
          d="M46.09,82.15l2.4.66a1,1,0,0,1,.65,1.36l-1.92,4.48-3.53-1.87,1.18-4A1,1,0,0,1,46.09,82.15Z" />
        <path
          class="cls-16"
          d="M44.16,85.9a2.5,2.5,0,1,1,4.41,2.34l-.46.88-4.42-2.34Z" />
        <path
          class="cls-14"
          d="M46.86,75.45l4.64,1a1,1,0,0,0,1.18-.71L53.44,73a1,1,0,0,0-.5-1.15l-1.06-.56L51,72,49.21,71Z" />
        <line
          class="cls-17"
          x1="51.6"
          y1="73.99"
          x2="49.8"
          y2="74.18" />
        <rect
          class="cls-18"
          x="46.07"
          y="62.5"
          width="3.5"
          height="2"
          transform="translate(35.31 -15) rotate(27.92)" />
        <rect
          class="cls-18"
          x="51.81"
          y="65.55"
          width="3.5"
          height="2"
          transform="translate(37.4 -17.33) rotate(27.92)" />
        <line
          class="cls-7"
          x1="48.9"
          y1="65.21"
          x2="51.55"
          y2="66.61" />
        <path
          class="cls-18"
          d="M53.08,62.89l-2-1a.52.52,0,0,1-.25-.57l.25-1a.5.5,0,0,1,.72-.32l2.4,1.27a.5.5,0,0,1,.14.78l-.69.77A.49.49,0,0,1,53.08,62.89Z" />
        <path
          class="cls-14"
          d="M57.7,62.79l2.08.36a1,1,0,0,1,.72,1.46l-.5.92a1,1,0,0,1-1,.52l-1.76-.31a1,1,0,0,1-.81-1.15l.17-1A1,1,0,0,1,57.7,62.79Z" />
        <path
          class="cls-14"
          d="M38.45,60l4.8-.51-.58.35,1.57,2.56-5.47.58a1.5,1.5,0,1,1-.32-3Z" />
        <path
          class="cls-14"
          d="M45.61,58a.36.36,0,0,0,0,.09l.87,1.55a1,1,0,0,0,1.31.41l-3.59,2.31L42.67,59.8Z" />
        <path
          class="cls-14"
          d="M49.14,58.16l-1-1.84a1,1,0,0,0-1.62-.17l-.7.78a1,1,0,0,0-.13,1.16l.87,1.55a1,1,0,0,0,1.37.38l.87-.49A1,1,0,0,0,49.14,58.16Z" />
        <path
          class="cls-14"
          d="M56.88,58.69a2.5,2.5,0,0,0-4.42-2.35l-.47.89a2.5,2.5,0,1,0,4.42,2.34Z" />
        <polyline
          class="cls-7"
          points="58.52 55.59 55.14 56.63 54.1 53.25" />
        <line
          class="cls-19"
          x1="55.14"
          y1="56.63"
          x2="55.84"
          y2="55.31" />
        <line
          class="cls-19"
          x1="53.03"
          y1="60.61"
          x2="53.5"
          y2="59.72" />
        <path
          class="cls-10"
          d="M56.52,71H54v5h2.5a2.5,2.5,0,1,0,0-5Z" />
        <path
          class="cls-10"
          d="M60,39.47V37a10,10,0,0,0-20,0v2.5a2,2,0,0,0,0,4h.12a10,10,0,0,0,19.76,0H60a2,2,0,1,0,0-4Z" />
        <path
          class="cls-7"
          d="M55.52,40.47a1.63,1.63,0,0,0-3,0" />
        <path
          class="cls-7"
          d="M47.53,40.47a1.63,1.63,0,0,0-3,0" />
        <circle
          class="cls-13"
          cx="44.27"
          cy="43.72"
          r="1.25" />
        <circle
          class="cls-13"
          cx="55.77"
          cy="43.72"
          r="1.25" />
        <path
          class="cls-7"
          d="M47,46.27a4.36,4.36,0,0,0,6,0" />
        <path
          class="cls-20"
          d="M41.52,37s9,.5,14.5-6a17.35,17.35,0,0,1,2.5,9.5A1.47,1.47,0,0,0,60,39a3.13,3.13,0,0,0,2.5-3c0-2.5,0-8.5-5.5-8.5,0,0-6-6-14.5-.5a11.88,11.88,0,0,0-5,10.5A1.47,1.47,0,0,0,39,39a2.23,2.23,0,0,0,2,1.5S41,37,41.52,37Z" />
        <path
          class="cls-21"
          d="M37.6,38a12,12,0,0,1,4.92-8c8.5-5.5,14.5.5,14.5.5,4.18,0,5.18,3.46,5.43,6.22a3.82,3.82,0,0,0,.07-.72c0-2.5,0-8.5-5.5-8.5,0,0-6-6-14.5-.5a11.88,11.88,0,0,0-5,10.5A1.82,1.82,0,0,0,37.6,38Z" />
        <path
          class="cls-7"
          d="M41.52,37s9,.5,14.5-6a17.35,17.35,0,0,1,2.5,9.5A1.47,1.47,0,0,0,60,39a3.13,3.13,0,0,0,2.5-3c0-2.5,0-8.5-5.5-8.5,0,0-6-6-14.5-.5a11.88,11.88,0,0,0-5,10.5A1.47,1.47,0,0,0,39,39a2.23,2.23,0,0,0,2,1.5S41,37,41.52,37Z" />
        <path
          class="cls-22"
          d="M40.52,67v2a2,2,0,0,0,2,2H54v5a1,1,0,0,1-1,1H42.52a8,8,0,0,1-8-8l0-1" />
      </g>
      <g class="cls-23">
        <path
          class="cls-24"
          d="M137.43,26.64a3,3,0,0,0-2.94-2.51,118.4,118.4,0,0,0-20,1.79A106.06,106.06,0,0,0,96,30.48,3,3,0,0,0,94,33.79l3.54,21.34a3,3,0,0,0,2.91,2.51,105.67,105.67,0,0,0,19-1.67A118.72,118.72,0,0,0,139,51.21a3,3,0,0,0,2-3.32Z" />
        <path
          class="cls-7"
          d="M137.43,26.64a3,3,0,0,0-2.94-2.51,118.4,118.4,0,0,0-20,1.79A106.06,106.06,0,0,0,96,30.48,3,3,0,0,0,94,33.79l3.54,21.34a3,3,0,0,0,2.91,2.51,105.67,105.67,0,0,0,19-1.67A118.72,118.72,0,0,0,139,51.21a3,3,0,0,0,2-3.32Z" />
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  .cls-1,
  .cls-17,
  .cls-19,
  .cls-7 {
    fill: none;
  }

  .cls-2 {
    fill: #e8f4fa;
  }

  .cls-3 {
    clip-path: url(#clip-path);
  }

  .cls-4 {
    fill: #f0ffe5;
  }

  .cls-10,
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-18,
  .cls-22,
  .cls-4,
  .cls-7 {
    stroke: #191816;
  }

  .cls-10,
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-22,
  .cls-4,
  .cls-7 {
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .cls-22,
  .cls-5 {
    fill: #c8ffa1;
  }

  .cls-6 {
    fill: #9ceb60;
  }

  .cls-8 {
    fill: #6dd627;
  }

  .cls-9 {
    fill: #46b000;
  }

  .cls-10,
  .cls-12 {
    fill: #ffda8f;
  }

  .cls-11 {
    fill: #e4ffd1;
  }

  .cls-13 {
    fill: #ffbe3d;
  }

  .cls-14 {
    fill: #fff;
  }

  .cls-15 {
    fill: #00b8f0;
  }

  .cls-16 {
    fill: #ff6242;
  }

  .cls-17 {
    stroke: #ffe500;
  }

  .cls-18 {
    fill: #ffe500;
  }

  .cls-19 {
    stroke: #ff6242;
  }

  .cls-20 {
    fill: #614b44;
  }

  .cls-21 {
    fill: #947063;
  }

  .cls-23 {
    clip-path: url(#clip-path-2);
  }

  .cls-24 {
    fill: #ffb0ca;
  }
</style>
